import { render, staticRenderFns } from "./PengajuanGadai.vue?vue&type=template&id=0bffabd3&scoped=true&"
import script from "./PengajuanGadai.vue?vue&type=script&lang=js&"
export * from "./PengajuanGadai.vue?vue&type=script&lang=js&"
import style0 from "./PengajuanGadai.vue?vue&type=style&index=0&id=0bffabd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bffabd3",
  null
  
)

export default component.exports